<div
  class="custom-message-container"
  [ngClass]="{ 'message-container-hidden': hiddenMessageContainer() }"
>
  <div
    *ngFor="let message of messages"
    class="custom-message {{ message.type }} {{ isVisibleMap[message.id] ? 'visible' : '' }}"
  >
    <mat-icon *ngIf="message.icon" class="message-icon">{{ message.icon }}</mat-icon>
    <div>
      <div *ngIf="message.title" class="message-title">{{ message.title }}</div>
      <div class="message-text">{{ message.text }}</div>
    </div>
    <mat-icon class="close-icon" (click)="closeMessage(message.id)">close</mat-icon>
  </div>
</div>
